var map = {
	"./arch/arch-inf-sel.svg": "c5ac",
	"./arch/arch-sup-sel.svg": "ff95",
	"./custom-pin/custom-pin-sel.svg": "74d1b",
	"./gum/gum-sel.svg": "0e03",
	"./milling/milling-sel.svg": "9bcd",
	"./stump/stump-sel.svg": "69b7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "91cf";